export default __webpack_public_path__ + "img/grande-cuvee.asset.5c5a2b7d.png";